var apiService = require('./api-service');
var apigClientFactory = require('aws-api-gateway-client').default;

export default class EntryData {
  static getData (callback) {
    var config = { invokeUrl: apiService.baseURL }
    var apigClient = apigClientFactory.newClient(config);
    var params = {};
    var pathTemplate = '/api/sociogram/list/entries/'
    var method = 'GET';
    var additionalParams = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      }
    };
    var body = {
    };
    
    apigClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then(function(result){
        //This is where you would put a success callback
        console.log("Success - " + JSON.stringify(result));
        callback (EntryData.sortByKey(result.data.socioData, "surname"));
        return;
    }).catch( function(result){
      console.log("Fail - " + result);
      return;
      //This is where you would put an error callback
    });
  }
  
  static async getEntriesBySociogram(sociogram, accessToken) {
    try {
      // Validate inputs before sending to API
      if (!sociogram || typeof sociogram !== 'string' || !sociogram.trim()) {
        throw new Error('Invalid sociogram parameter');
      }
      
      if (!accessToken || typeof accessToken !== 'string') {
        throw new Error('Missing or invalid access token');
      }
  
      // Sanitize the sociogram parameter to prevent path traversal
      const sanitizedSociogram = encodeURIComponent(sociogram.trim());
      
      // Set a timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch(`/api/sociogram/list/entries/${sanitizedSociogram}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // Helps prevent CSRF
        },
        credentials: 'same-origin', // Only send cookies for same-origin requests
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();
      
      // Sort the results by surname
      return EntryData.sortByKey(data, "surname");
      
    } catch (error) {
      // Don't expose detailed error messages to console in production
      console.error('Error fetching entries data:', error.message);
      
      // Rethrow with generic message for client-side handling
      throw new Error('Failed to fetch sociogram entries');
    }
  }

  static sortByKey(array, key) {
      return array.sort(function(a, b) {
          var x = a[key]; var y = b[key];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
  }
}